import type * as Style from '../../index.js'
import { FixElementRuleIds, RuleId, ValidatedArray } from '../../values/index.js'

export const Props = (props: any = {}) => ({
  typographyIds: ValidatedArray(RuleId, props.typographyIds),
  paletteIds: ValidatedArray(RuleId, props.paletteIds)
})
export const fix = (props: Props, styles: Style.Rule[]): Props => ({
  paletteIds: FixElementRuleIds('palette', props.paletteIds, styles),
  typographyIds: FixElementRuleIds('typography', props.typographyIds, styles)
})

export type Props = ReturnType<typeof Props>
export const validate = () => true
export const type = 'text'
export const label = 'Text elements'
export const category = 'element'
export const aspects = ['typography', 'palette'] as const
